import React from 'react';

const BillingToggle = ({ isYearly, setIsYearly }) => {
  return (
    <div className="flex justify-center mb-8">
      <div className="relative inline-flex items-center bg-gray-100 rounded-full p-1 shadow-sm">
        <div 
          className="absolute top-1 bottom-1 bg-black rounded-full transition-all duration-500 ease-in-out"
          style={{ 
            width: '50%', 
            transform: isYearly ? 'translateX(100%)' : 'translateX(0)',
          }}
        />
        <button 
          className={`w-36 py-2 rounded-full relative z-10 transition-colors duration-500 font-medium text-center ${!isYearly ? 'text-white' : 'text-gray-700'}`}
          onClick={() => setIsYearly(false)}
        >
          Monthly
        </button>
        <div className="relative">
          <button 
            className={`w-36 py-2 rounded-full relative z-10 transition-colors duration-500 font-medium text-center ${isYearly ? 'text-white' : 'text-gray-700'}`}
            onClick={() => setIsYearly(true)}
          >
            Yearly
          </button>
          <div className="absolute -top-3 -right-2 bg-purple-600 text-white text-xs font-bold px-3 py-1 rounded-full transform rotate-3 shadow-md">
            -25%
          </div>
        </div>
      </div>
    </div>
  );
};

export default BillingToggle;